import React from "react";

// This context is used to render the Hero theme
// Possible values are "light" and "dark".
const HeaderContext = React.createContext();

export default HeaderContext;
